
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-all-india-mains-mock-test",
      function () {
        return require("private-next-pages/upsc-all-india-mains-mock-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-all-india-mains-mock-test"])
      });
    }
  